// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__1IRBm","paramInput":"JobSimulator_paramInput__2Jxy4","input":"JobSimulator_input__1Gr_i"};